import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`

export const Title = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
`

export const Subtitle = styled.div`
  overflow: hidden;
  color: var(--text-secondary);
  text-overflow: ellipsis;
  font-family: var(--font-family-body);
  font-size: var(--font-size-300);
  font-style: normal;
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-300);
  letter-spacing: var(--font-letter-spacing-loose);
`
